




























import {
  computed,
  defineComponent,
  getCurrentInstance,
  ref,
  PropType,
} from '@vue/composition-api'

import ExportImportButton from '@/components/molecules/h/ExportImportButton.vue'
import ExtractCondition from '@/components/organisms/h/page/yosan-haibun/weekly-daily-budget-conf/ExtractCondition.vue'
import OutputCondition from '@/components/organisms/h/page/yosan-haibun/weekly-daily-budget-conf/OutputCondition.vue'
import TitleAndManipulate from '@/components/organisms/h/TitleAndManipulate.vue'
import {
  outputCondUseInfoList,
  WeeklyDailyBudgetConfExtractCondition,
  WeeklyDailyBudgetConfOutputCondition,
} from '@/types/entities'
export default defineComponent({
  components: {
    TitleAndManipulate,
    ExtractCondition,
    OutputCondition,
    ExportImportButton,
  },
  props: {
    outputUseList: {
      type: Array as PropType<outputCondUseInfoList>,
      default: () => [],
    },
    totalCount: {
      type: String as PropType<string>,
      default: null,
    },
    exportSpinner: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    exportErrorMessage: {
      type: String as PropType<string>,
      default: '',
    },
  },
  setup(props, context) {
    const instance = getCurrentInstance()
    if (!instance) {
      // should be called in setup
      return
    }
    const { $i18n } = instance.proxy

    const requestExport = () => {
      context.emit('request-export')
    }
    const requestImport = () => {
      context.emit('request-import')
    }

    const changeExtractCondition = (
      cond: WeeklyDailyBudgetConfExtractCondition
    ) => {
      console.log('page_view_changeExtractCondition', { cond })
      context.emit('change-extract-condition', cond)
    }
    const changeOutputCondition = (
      cond: WeeklyDailyBudgetConfOutputCondition
    ) => {
      context.emit('change-output-condition', cond)
    }
    return {
      requestExport,
      requestImport,
      changeExtractCondition,
      changeOutputCondition,
    }
  },
})
